"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _classnames = _interopRequireDefault(require("classnames"));
var _compose = _interopRequireDefault(require("ramda/src/compose"));
var _mergeLeft = _interopRequireDefault(require("ramda/src/mergeLeft"));
var _chevron = require("@catalytic/catalytic-icons/lib/glyphs/chevron.svg");
var _styles = require("@material-ui/styles");
var _AvatarV = _interopRequireDefault(require("../AvatarV2/AvatarV2"));
var _Grid = _interopRequireDefault(require("../../Grid/Grid"));
var _Text = require("../../Text/Text");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    container: {
      padding: '0.375rem 1rem',
      height: '3rem',
      textAlign: 'left'
    },
    clickable: {
      '&:active, &:focus, &:hover': {
        backgroundColor: theme.colors.blueGrey
      }
    },
    active: {
      backgroundColor: theme.colors.blueGrey,
      '&:active, &:focus, &:hover': {
        backgroundColor: theme.colors.blueGrey
      }
    },
    disabled: theme.mixins.disabled,
    skeleton: {
      backgroundColor: theme.colors.white,
      '&:active, &:focus, &:hover': {
        backgroundColor: theme.colors.white
      },
      '& > div': {
        borderRadius: theme.variables.borderRadiusSmall,
        backgroundColor: theme.colors.lightGrey,
        '& $avatar, & $displayName, & $description, & $angleBracket': {
          visibility: 'hidden'
        }
      }
    },
    avatarContainer: {
      marginRight: '0.75rem',
      '&>div': {
        // override inline-block so the icon aligns vertically with the item text
        display: 'block!important'
      }
    },
    avatar: {
      '&, &:active, &:focus, &:hover, &>svg': {
        padding: 0,
        width: '1.5rem',
        height: '1.5rem',
        borderRadius: 0
      }
    },
    displayName: _objectSpread(_objectSpread({}, theme.mixins.truncate), {}, {
      display: 'block',
      color: theme.colors.pebbleGrey,
      fontWeight: '500'
    }),
    description: _objectSpread(_objectSpread({}, theme.mixins.truncate), {}, {
      display: 'block',
      color: theme.colors.battleshipGrey
    }),
    angleBracketContainer: {
      marginLeft: '0.75rem'
    },
    angleBracket: {}
  };
});
/*:: type Props = {|
  active?: boolean,
  angleBracket?: boolean,
  backgroundColor?: string,
  className?: string,
  clickable?: boolean,
  description?: string | React.Element<typeof FormattedMessage>,
  // Applies grayscale, reduced opacity styles for displayName and description,
  // but leaves icon colors as-is
  disabled?: boolean,
  displayName: string | React.Element<typeof FormattedMessage>,
  icon?: React.Node,
  iconSrc?: string,
  skeleton?: boolean,
  unread?: boolean
|};*/
var SmallListItem = function SmallListItem(_ref /*:: */) {
  var active = _ref /*:: */.active,
    angleBracket = _ref /*:: */.angleBracket,
    backgroundColor = _ref /*:: */.backgroundColor,
    className = _ref /*:: */.className,
    _ref$clickable = _ref /*:: */.clickable,
    clickable = _ref$clickable === void 0 ? true : _ref$clickable,
    description = _ref /*:: */.description,
    disabled = _ref /*:: */.disabled,
    displayName = _ref /*:: */.displayName,
    icon = _ref /*:: */.icon,
    iconSrc = _ref /*:: */.iconSrc,
    skeleton = _ref /*:: */.skeleton,
    unread = _ref /*:: */.unread;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(_Grid.default, {
    alignItems: "center",
    className: (0, _classnames.default)(classes.container, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.clickable, clickable), classes.active, active && !skeleton), classes.skeleton, skeleton), className),
    container: true
  }, /*#__PURE__*/React.createElement(_Grid.default, {
    className: classes.avatarContainer,
    item: true
  }, /*#__PURE__*/React.createElement(_AvatarV.default, {
    appearance: "square",
    borderColor: "transparent",
    className: classes.avatar,
    component: function component(_ref2) {
      var className = _ref2.className,
        children = _ref2.children;
      return /*#__PURE__*/React.createElement("span", {
        className: className
      }, icon || children);
    },
    presence: unread && !skeleton ? 'online' : undefined,
    size: "small",
    src: iconSrc,
    theme: function theme(current, props) {
      return (0, _compose.default)((0, _mergeLeft.default)({
        backgroundColor: backgroundColor || 'transparent',
        borderRadius: 0,
        dimensions: {
          width: 'auto',
          height: 'auto'
        },
        presence: {
          bottom: 'auto',
          left: 'auto',
          right: '-.25rem',
          top: '-.25rem',
          height: '.75rem',
          width: '.75rem'
        }
      }), current)(props);
    }
  })), /*#__PURE__*/React.createElement(_Grid.default, {
    className: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.disabled, disabled && !skeleton)),
    item: true,
    xs: true,
    zeroMinWidth: true
  }, /*#__PURE__*/React.createElement(_Text.ExtraSmallText, {
    className: classes.displayName
  }, displayName), description && /*#__PURE__*/React.createElement(_Text.ExtraSmallText, {
    className: classes.description
  }, description)), angleBracket && /*#__PURE__*/React.createElement(_Grid.default, {
    className: classes.angleBracketContainer,
    item: true
  }, /*#__PURE__*/React.createElement(_chevron.ReactComponent, {
    className: classes.angleBracket
  })));
};
SmallListItem.displayName = 'SmallListItem';
var _default = exports.default = SmallListItem;
//# sourceMappingURL=SmallListItem.js.map